<template>
  <div class="section_info">
    <b-container>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12"><div class="H2">{{title[language]}}</div></b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="main_text">
            {{text[language]}}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="main_btn">
            <b-button size="lg">{{buttom[language]}}</b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AppInfo',
  props: {
    language: {
      type: String,
      default: 'ru'
    }
  },
  data() {
    return {
      title: {
        ru: 'Немного о компании',
        en: 'About company'
      },
      text: {
        ru: 'Компания «Радуга-НН» является эксклюзивным импортером автокомпонентов на рынок России. Мы решаем полный комплекс задач от ввоза продукции до ее реализации через налаженную сеть дистрибьюторов. 20 лет опыта в данной сфере дают гарантию успешного СТАРТА завоевания потребителей России.',
        en: 'Company "Raduga-NN" is the exclusive importer of autocomponents to the Russian market. We solve the full range of tasks from the import of products to its realization through an established network of distributors. 20 years of experience in this field provide a guarantee of a successful START of the win of Russian consumers.'
      },
      buttom: {
        ru: 'Стать партнером',
        en: 'Partnership'
      },
    };
  }
}
</script>

<style lang="scss">
.section_info{
  background: #fff;
  padding: 20px 0;
}
.section_info .main_text{
  font-size: 18px;
  text-align: justify;
}
.section_info .main_btn{
  text-align: center;
  margin-top: 15px
}
.section_info .main_btn button{
  background: #94bd25
}
</style>


// WEBPACK FOOTER //
// src/views/Info.vue